import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { EChartsOption } from 'echarts';
import * as echarts from 'echarts';
import { IRiskSingleGraph } from 'src/app/models/riskProfile';

@Component({
  selector: 'app-risk-bar-graph',
  templateUrl: './risk-bar-graph.component.html',
  styleUrl: './risk-bar-graph.component.scss',
})
export class RiskBarGraphComponent implements OnInit, AfterViewInit {
  chartOption: EChartsOption;
  height = '';
  hightestScore: number = 0;
  scoreTotal: number = 0;
  @ViewChild('echartsElement') echartsElement: ElementRef<HTMLInputElement>;
  myChart: any; // Define myChart variable
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set chartData(val: IRiskSingleGraph[]) {
    if (val.length > 0) this.setGraph(val);
  }
  constructor(private cdref: ChangeDetectorRef) {}
  ngOnInit(): void {
    // this.renderChart();
  }
  ngAfterViewInit(): void {
    this.renderChart();
    this.cdref.detectChanges();
  }
  renderChart(): void {
    // Initialize ECharts instance
    this.myChart = echarts.init(this.echartsElement.nativeElement);
    // Enable data zoom when user click bar.
  }
  setGraph(val: IRiskSingleGraph[]) {
    const copiedDatesArray = val.slice();
    this.hightestScore = Math.max(...val.map((item) => item.incidentScores));
    this.scoreTotal = val.reduce(
      (total, item) => total + item.incidentScores,
      0
    );
    // prettier-ignore
    // let dataAxis = ['点', '击', '柱', '子', '或', '者', '两', '指', '在', '触', '屏', '上', '滑', '动', '能', '够', '自',];
    let dataAxis = copiedDatesArray.map(item=>item.eventTime);
    // prettier-ignore
    // let data = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198,];
    let data = copiedDatesArray.map(item=>item.incidentScores)
    let yMax = 500;
    let dataShadow = [];

    for (let i = 0; i < data.length; i++) {
      dataShadow.push(yMax);
    }

    this.chartOption = {
      title: {
        text: 'Highest Score: ' + this.hightestScore,
        subtext: 'Total Score: ' + this.scoreTotal,
      },
      grid: {
        left: '10%',
        right: '2%',
        bottom: '10%',
        containLabel: false,
        width: '85%', // Adjust the width here
      },
      xAxis: {
        data: dataAxis,
        axisLabel: {
          inside: true,
          color: 'black',
          rotate: 90,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        z: 10,
      },
      yAxis: {
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: '#999',
        },
      },
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      series: [
        {
          type: 'bar',
          showBackground: true,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' },
            ]),
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' },
              ]),
            },
          },
          data: data,
        },
      ],
    };

    // Enable data zoom when user click bar.
    const zoomSize = 6;
    if (this.myChart)
      this.myChart.on('click', (params: any) => {
        this.myChart.dispatchAction({
          type: 'dataZoom',
          startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
          endValue:
            dataAxis[
              Math.min(params.dataIndex + zoomSize / 2, data.length - 1)
            ],
        });
      });
  }
}
